"use client"

import React from 'react';
import styles from "./Languages.module.css";
import {useLocale} from "use-intl";
import {useRouter} from "@/i18n/routing";
import {Stack, Switch} from "@mui/material";

export default function Languages() {
  const locale = useLocale()
  const router = useRouter()

  return <div className={styles.container}>
    <Stack direction="row" spacing={0} sx={{alignItems: 'center'}}>
      <svg width={20} xmlns="http://www.w3.org/2000/svg" id="flag-icons-gb" viewBox="0 0 640 480">
        <path fill="#012169" d="M0 0h640v480H0z"/>
        <path fill="#FFF" d="m75 0 244 181L562 0h78v62L400 241l240 178v61h-80L320 301 81 480H0v-60l239-178L0 64V0z"/>
        <path fill="#C8102E"
              d="m424 281 216 159v40L369 281zm-184 20 6 35L54 480H0zM640 0v3L391 191l2-44L590 0zM0 0l239 176h-60L0 42z"/>
        <path fill="#FFF" d="M241 0v480h160V0zM0 160v160h640V160z"/>
        <path fill="#C8102E" d="M0 193v96h640v-96zM273 0v480h96V0z"/>
      </svg>
      <Switch size={"small"} color="secondary" onChange={() => {
        router.replace('/home', {locale: locale === "it" ? 'en' : 'it'})
      }} defaultChecked={locale === "it"} slotProps={{input: {'aria-label': 'ant design'}}}/>
      <svg width={20} xmlns="http://www.w3.org/2000/svg" id="flag-icons-it" viewBox="0 0 640 480">
        <g fillRule="evenodd" strokeWidth="1pt">
          <path fill="#fff" d="M0 0h640v480H0z"/>
          <path fill="#009246" d="M0 0h213.3v480H0z"/>
          <path fill="#ce2b37" d="M426.7 0H640v480H426.7z"/>
        </g>
      </svg>
    </Stack>
  </div>
}
